import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReason2FurnitureTrolleyLoaded = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#0058A3",
		fillRule: "evenodd",
		d: "M5.5 3a2.5 2.5 0 0 0-2.3 1.3C3.2 4.5 3 5 3 6v11h18v-2H8V6c0-1 0-1.4-.3-1.8a2 2 0 0 0-.9-.9C6.5 3.1 6 3 5.5 3zM5 15V5h1v10H5zm-1 4.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0zm13 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0zM10 11h11v2H10v-2zm11-3H10v2h11V8zM10 5h6v2h-6V5z",
		clipRule: "evenodd"
	})
});
export default SvgReason2FurnitureTrolleyLoaded;
